var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEventBlack18Dp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M19.556,24H2.445A2.426,2.426,0,0,1,0,21.6L.012,4.8A2.419,2.419,0,0,1,2.445,2.4H3.667V0H6.111V2.4h9.779V0h2.444V2.4h1.223A2.425,2.425,0,0,1,22,4.8V21.6A2.425,2.425,0,0,1,19.556,24ZM2.445,8.4V21.6H19.556V8.4ZM17.111,19.2H11v-6h6.111v6Z",
    transform: "translate(0.5 0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEventBlack18Dp);
export default __webpack_public_path__ + "static/media/icon-event-black-18dp.22ef68f9d967396eaa94b075a324bc38.svg";
export { ForwardRef as ReactComponent };